module.exports = "/work-site/img/rotation.542502c6.png";